import $ from 'jquery';
import imagesLoaded from 'imagesloaded';

import SiteHeader from "./components/site-header";
import NewsSlider from "./components/news-slider";
import ServicesSlider from "./components/services-slider";
import ReviewsSlider from "./components/reviews-slider";
import PacksSlider from "./components/packs-slider";
import HomePacksSlider from "./components/home-packs-slider";
import ProductsSlider from "./components/products-slider";
import PartnersSlider from "./components/partners-slider";
import HandheldMenu from "./components/handheld-menu";
import SecondaryMenu from "./components/secondary-menu";
import CookiesConsent from "./components/cookies-consent";
import Accordion from "./components/accordion";
import Gallery from "./components/gallery";
import SearchToggler from "./components/search-toggler";
import ScrollInView from "./components/scroll-in-view";

import DeviceManager from "./utils/device-manager";

// (function ($) {
	// window.$ = $;

$(function () {

	const bootstrapApp = () => {
		const $html = $("html");

		// Touch device detection
		if (DeviceManager.isHandheld()) {
			$html.addClass("touch");

			if (DeviceManager.isIos()) {
				$html.addClass("ios");
			}
		} else {
			$html.addClass("no-touch");
		}

		// IE detection
		if (DeviceManager.isIe11()) {
			$html.addClass("ie11");
		} else if (DeviceManager.isEdge()) {
			$html.addClass("edge");
		}
	}
	
	const instanciateComponents = () => {
		// General components
		const siteHeader = new SiteHeader($(".site-header"), 20);


		// News slider component
		const $newsSliders = $(".home-news .news-list");
		if ($newsSliders.length) {
			$newsSliders.each(function (index, el) {
				const newsSlider = new NewsSlider($(el));
			});
		}

		// Services slider component
		const $servicesSliders = $(".home-services .services__wrapper");
		if ($servicesSliders.length) {
			$servicesSliders.each(function (index, el) {
				const servicesSlider = new ServicesSlider($(el));
			});
		}

		// Packs slider component
		const $packsSliders = $(".packs-section .packs-list");
		if ($packsSliders.length) {
			$packsSliders.each(function (index, el) {
				const packSlider = new PacksSlider($(el));
			});
		}

		// Home packs slider component
		const $homePacksSliders = $(".home-packs .packs-list");
		if ($homePacksSliders.length) {
			$homePacksSliders.each(function (index, el) {
				const homePackSlider = new HomePacksSlider($(el));
			});
		}

		// Products slider component
		const $productsSliders = $(".products-list--slider");
		if ($productsSliders.length) {
			$productsSliders.each(function (index, el) {
				const productSlider = new ProductsSlider($(el));
			});
		}

		// Partners slider component
		const $partnersSliders = $(".partners-slider");
		if ($partnersSliders.length) {
			$partnersSliders.each(function (index, el) {
				const partnerSlider = new PartnersSlider($(el));
			});
		}

		// Reviews slider component
		const $reviewsSlider = $(".reviews-slider");
		if ($reviewsSlider.length) {
			$reviewsSlider.each(function (index, el) {
				const reviewsSlider = new ReviewsSlider($(el));
			});
		}

		// Scroll in view component
		const $scrollInViewElements = $(".scroll-in-view");
		if ($scrollInViewElements.length) {
			$scrollInViewElements.imagesLoaded(function () {
				const scrollInView = new ScrollInView($scrollInViewElements);
			});
		}

		// ici le code pour le carrousel de témoignages
		const $slidesReview = $('.reviews-slider.flickity-enabled .reviews-slider__slide');
		const slideSelected = $('.reviews-slider.flickity-enabled .reviews-slider__slide.is-selected');

		if ($slidesReview.length) {
			// const $slidesNoHover = $('.reviews-slider.flickity-enabled .reviews-slider__slide:not(.js-hover)');
			/* slideSelected.addEventListener("mouseover", (event) => {
				el.classList.remove('js-hover');
			});
			slideSelected.addEventListener("mouseout", (event) => {
				el.classList.remove('js-hover');
			}); */
			$slidesReview.each(function (index, el) {
				if( !el.classList.contains('is-selected')) {
					el.addEventListener("mouseover", (event) => {
						$slidesReview.each(function (index, el) {
							el.classList.add('js-no-hover');
						});
						el.classList.remove('js-no-hover');
						el.classList.add('js-hover');

					});
					el.addEventListener("mouseout", (event) => {
						$slidesReview.each(function (index, el) {
							el.classList.remove('js-no-hover');
						});
						el.classList.remove('js-hover');

					});
				}
				
			})
		}
		
	}

	bootstrapApp();
	instanciateComponents();

});

// })(jQuery);
